import { DifficultyLevel } from '../interfaces/question.interface';
import { BalanceRound } from '../interfaces/balance-it.interface';

interface Conv { from: string; to: string; factor: number; measure: 'length' | 'capacity' | 'mass'; }

// Metric power-of-ten conversions, bigger unit → smaller (whole-number answers).
const EASY: Conv[] = [
  { from: 'cm', to: 'mm', factor: 10, measure: 'length' }
];
const MEDIUM: Conv[] = [
  { from: 'm', to: 'cm', factor: 100, measure: 'length' }
];
const HARD: Conv[] = [
  { from: 'km', to: 'm', factor: 1000, measure: 'length' },
  { from: 'L', to: 'mL', factor: 1000, measure: 'capacity' },
  { from: 'kg', to: 'g', factor: 1000, measure: 'mass' }
];

function randInt(lo: number, hi: number): number {
  return lo + Math.floor(Math.random() * (hi - lo + 1));
}

function toRound(conv: Conv, d: DifficultyLevel, idx: number): BalanceRound {
  const fromValue = randInt(2, 9);
  const factor = conv.factor;
  const answer = fromValue * factor;
  const step = Math.max(1, factor / 10);
  const gaugeMax = (fromValue + 3) * factor;   // headroom so over-guesses tip it
  return {
    id: `bal-${idx}-${fromValue}${conv.from}`,
    fromValue, fromUnit: conv.from, toUnit: conv.to,
    factor, answer, step, gaugeMax, measure: conv.measure, difficulty: d
  };
}

const pick = <T>(a: T[]): T => a[Math.floor(Math.random() * a.length)];

/**
 * Build a session's rounds on an easy→hard ramp: ×10 (cm→mm), then ×100
 * (m→cm), then ×1000 (km→m / L→mL / kg→g, cycling the measure for variety).
 */
export function buildBalanceItRounds(count: number): BalanceRound[] {
  const n = Math.max(1, count);
  const out: BalanceRound[] = [];
  let hardIdx = 0;
  for (let i = 0; i < n; i++) {
    const t = n === 1 ? 0 : i / (n - 1);
    if (t < 0.3) out.push(toRound(pick(EASY), DifficultyLevel.EASY, i));
    else if (t < 0.55) out.push(toRound(pick(MEDIUM), DifficultyLevel.MEDIUM, i));
    else out.push(toRound(HARD[hardIdx++ % HARD.length], DifficultyLevel.HARD, i));
  }
  return out;
}
